import AddressBook from "@/assets/data/AddressBook.json"
import { addToMap, deepClone, getIdList, getVarType, object2Str } from "./common"
import _ from "lodash"
import dj from "dayjs"
const isSameOrBefore = require("dayjs/plugin/isSameOrBefore")
const isSameOrAfter = require("dayjs/plugin/isSameOrAfter")
dj.extend(isSameOrBefore)
dj.extend(isSameOrAfter)
import store from "@/store"
import { noValCompareMethod } from "~/data/static"
import {
  getCompany,
  getDepartment,
  getUser,
  getUserIdsByDepartment,
  getUserIdsByRole,
  getUsers,
  getLevelDepartmentIds
} from "@/utils/user"
import {
  commonExpressions,
  timeTypeList,
  weekOptionList,
  timeUnitMap
} from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/static"
import { quarters, halfYears } from "@/components/BaseComponents/static"
import { getDistance, searchLocation } from "./location"
import { getSheetViewData } from "@/api/sheet/sheetView"
import { getSheetDataById } from "@/api/sheet/sheetData"

// 可以用于计算字段的字段类型
export const canCalcFieldTypes = [
  "number",
  "money",
  "field",
  "gather",
  "time",
  "location",
  "option"
]
// 不可编辑的字段类型
export const disabledFieldTypes = [
  "sn",
  "calc",
  "gather",
  "field",
  "remark",
  "money_cn",
  "str_calc"
]
// 值是数组的字段类型
export const arrayValueTypes = ["ref", "staff", "file", "option", "department", "area", "company"]
// 支持设置默认值的字段类型
export const supportDefaultTypes = [
  "text",
  "staff",
  "department",
  "company",
  "number",
  "money",
  "money_cn",
  "option",
  "area",
  "ref",
  "time"
]

// 获得各级地址数据
export function getAllLevelAddress(level = 3) {
  let address = []
  for (let provinceName in AddressBook) {
    let cities = []
    for (let cityName in AddressBook[provinceName]) {
      let counties = []
      let countyMap = AddressBook[provinceName][cityName]
      for (const countyCode in countyMap) {
        counties.push({
          code: countyCode,
          label: countyMap[countyCode],
          value: countyMap[countyCode],
          leaf: level == 3
        })
      }
      cities.push({
        label: cityName,
        value: cityName,
        children: counties,
        leaf: level == 2
      })
    }
    address.push({
      label: provinceName,
      value: provinceName,
      children: cities,
      leaf: level == 1
    })
  }
  return address
}

export function verifyCondition(from, conditions) {
  let msg
  if (from === "submit") msg = "请将条件填写完整再提交"
  else if (from === "add") msg = "请将条件填写完整再添加条件"
  else return { result: false, msg: "from不合法" }
  for (let item of _.flattenDeep(conditions)) {
    if (!item.key || !item.compareMethod) return { result: false, msg: msg }
    if (!noValCompareMethod.includes(item.compareMethod)) {
      // 值不能为空
      if (_.isEmpty(item.varItems)) return { result: false, msg: msg }
    }
  }
  return { result: true, msg: "" }
}

export function transFieldControl(control) {
  if (!(control._type === "field" && control._refControl)) {
    return control
  }
  let { name, _cid, main, required, display, isLeaf, hidden } = control
  return Object.assign({}, control._refControl, {
    name,
    _cid,
    main,
    required,
    display,
    isLeaf,
    hidden,
    disabled: true,
    hint: "",
    defaultVal: null,
    isField: true
  })
}

export function decorateSheet(sheetDef) {
  if (!sheetDef) return null
  let sheet = _.cloneDeep(sheetDef)
  sheet.controls = sheet.controls?.map(control => transFieldControl(control))
  return sheet
}

// 根据 controls 的 defaultVal 获取一个 map： 字段=>该字段更新会影响哪些字段的默认值
export function transControlValRelyMap(controls) {
  let map = {}
  controls.forEach(control => {
    switch (control._type) {
      case "ref":
        // eslint-disable-next-line no-case-declarations
        let defaultRelyCid = _.get(control, "defaultVal.id", "")
        if (defaultRelyCid) {
          addToMap(map, defaultRelyCid, control._cid)
        }
        break
      case "company":
        _.get(control, "defaultVal.value", [])
          .filter(v => v.value[0] === "v")
          .forEach(v => addToMap(map, _.trimStart(v.value, "v"), control._cid))
        break
      case "department":
        if (control?.defaultVal?.type === "user") {
          addToMap(map, control?.defaultVal?.relatedCid, control._cid)
        } else if (control?.defaultVal?.type === "var") {
          _.get(control, "defaultVal.value", [])
            .filter(v => v.value[0] === "v")
            .forEach(v => addToMap(map, _.trimStart(v.value, "v"), control._cid))
        }
        break
      // eslint-disable-next-line no-fallthrough
      case "staff":
        _.get(control, "defaultVal.value", [])
          .filter(v => v.value[0] === "v")
          .forEach(v => {
            let relyCid = _.trimStart(v.value, "v")
            if ("CurrentUser" === relyCid) return
            addToMap(map, relyCid, control._cid)
          })
        break
      case "area":
        if (_.get(control, "defaultVal.isVar")) {
          let relyCid = _.trimStart(_.get(control, "defaultVal.value", ""), "v")
          addToMap(map, relyCid, control._cid)
        }
        break
      case "location":
        if (control.defaultVal?.value) {
          let relyCid = _.trimStart(control.defaultVal?.value, "v")
          if ("CurrentLocation" === relyCid) return
          addToMap(map, relyCid, control._cid)
        }
        break
      case "time": {
        if (_.get(control, "defaultVal.dateType") === "var") {
          addToMap(map, _.trimStart(_.get(control, "defaultVal.value", ""), "v"), control._cid)
        }
        break
      }
      default:
        // text
        ;(control.defaultVal?.arr || control.defaultVal?.outputTextArr || [])
          .filter(relyItem => relyItem.value) // 过滤普通字符串
          .forEach(relyItem => addToMap(map, _.trimStart(relyItem.value, "v"), control._cid))
    }
  })
  return map
}
// 关联字段 实时更新
export function transCalcValRelyMap(controls = [], skipControlTypes = []) {
  let map = {}
  for (let control of controls) {
    if (skipControlTypes.includes(control._type)) continue
    switch (control._type) {
      case "calc":
        if (control.calcType === "NUM") {
          controls
            .filter(c => control.expression.includes("v" + c._cid))
            .map(c => c._cid)
            .forEach(cid => addToMap(map, cid, control._cid))
        } else if (["DATE", "LOCATION"].includes(control.calcType)) {
          addToMap(map, control.var1, control._cid)
          addToMap(map, control.var2, control._cid)
        } else if (control.calcType === "OPTION") {
          addToMap(map, control.expression, control._cid)
          let expression = Object.values(control.optionValueMap).join(";")
          controls
            .filter(c => expression.includes("v" + c._cid))
            .map(c => c._cid)
            .forEach(cid => addToMap(map, cid, control._cid))
        }
        break
      case "sn":
        addToMap(map, control.key, control._cid)
        break
      case "gather":
        addToMap(map, control.sourceCid, control._cid)
        break
      case "money_cn":
        addToMap(map, control.refCid, control._cid)
        break
      case "str_calc":
        addToMap(map, control.expression, control._cid)
        break
    }
  }
  return map
}

// 获取设置默认值时，可以选择的变量类型
export function getCanUseType(type) {
  switch (type) {
    case "text":
      return [
        "select",
        "radio",
        "text",
        "money",
        "number",
        "rate",
        "time",
        "date",
        "location",
        "option",
        "staff",
        "department",
        "company"
      ]
    case "money":
    case "number":
      return ["money", "number"]
    case "date":
    case "time":
    case "staff":
    case "department":
    case "company":
    case "ref":
    case "telephone":
      return [type]
    case "address":
      return [""]
    case "area":
    case "location":
      return ["area", "location"]
    default:
      return []
  }
}

// 时间计算
export function timeCompute(defaultVal, control, time) {
  let controlType = control._type
  let format = controlType === "date" ? "YYYY-MM-DD" : "YYYY-MM-DD HH:mm:ss"
  if (!time) return null
  if (defaultVal.dateType !== "Custom") {
    for (let key in defaultVal.compute) {
      let val = Number(defaultVal.compute[key])
      if (val && !Number.isNaN(val)) {
        time = dj(time)
          .add(val, key)
          .format(format)
      }
    }
  }
  let unit = timeUnitMap[control.timeType]
  time = getDealTime(time, unit)
  return time
}

export function getDealTime(time, unit) {
  return (unit !== "halfYear" ? dj(time).startOf(unit) : dj(getHalfTime(time))).format(
    "YYYY-MM-DD HH:mm:ss"
  )
}

export function getHalfTime(time) {
  let year = dj(time).year()
  return year + (getHalf(time) === 1 ? "-01-01 00:00:00" : "-07-01 00:00:00")
}

// 根据control和form获取该字段的默认值
export async function getControlDefaultVal(control, form, controlMap) {
  switch (control?._type) {
    case "select": {
      return control.defaultVal
    }
    case "option": {
      // 有依赖关系的时候,仍然返回当前控件的默认值,因为在保存的时候也会校验选项是否存在
      // if (!_.isEmpty(control.linkage)) return control.oneFlag ? null : []
      return control.defaultVal || []
    }
    case "check":
    case "url":
    case "progress": {
      return control.defaultVal.value
    }
    case "department": {
      let departmentIds = []
      if (control?.defaultVal?.type === "user") {
        let userCid = control?.defaultVal?.relatedCid
        if (!userCid) {
          console.error("表结构部门字段设置有误,未配置关联的人员字段")
          return []
        }
        // 跟随某个人员字段变动
        let userId = form[userCid]
        if (_.isArray(userId)) {
          userId = userId[0]
        }
        if (_.isObject(userId)) {
          userId = userId.id
        }
        if (!userId) return []
        if ([1, 2, 4, 5].includes(control.defaultVal?.departmentLevel)) {
          let deptId = control.defaultVal.departmentLevel>=4?control.defaultVal.departmentLevel-1:control.defaultVal.departmentLevel;
          departmentIds = getLevelDepartmentIds(userId, deptId)
        } else {
          departmentIds = getUser(userId)?.companyScope?.departmentIds || []
        }
      } else {
        departmentIds = _.uniq(
          _.get(control, "defaultVal.value", [])
            .map(item => {
              return _.startsWith(item.value, "v")
                ? resolveDefaultVal(item.value, control._type, form, controlMap)
                : item.value
            })
            .filter(t => Boolean(t)) // 去除空值
            .flatMap(t => t)
        )
      }
      if (!departmentIds.length) return null
      return (control.oneFlag ? departmentIds.slice(0, 1) : departmentIds)
        .map(o => object2Str(o))
        .filter(t => t)
        .map(id => getDepartment(id))
    }
    case "company": {
      let companyIds = _.uniq(
        _.get(control, "defaultVal.value", [])
          .map(item => {
            return _.startsWith(item.value, "v")
              ? resolveDefaultVal(item.value, control._type, form, controlMap)
              : item.value
          })
          .filter(t => Boolean(t)) // 去除空值
          .flatMap(t => t)
      )
      if (!companyIds.length) return null
      return (control.oneFlag ? companyIds.slice(0, 1) : companyIds)
        .map(o => object2Str(o))
        .filter(t => t)
        .map(id => getCompany(id))
    }
    case "staff": {
      let vals = _.uniq(
        _.get(control, "defaultVal.value", [])
          .map(item => {
            return _.startsWith(item.value, "v")
              ? resolveDefaultVal(item.value, control._type, form, controlMap)
              : item.value
          })
          .filter(t => Boolean(t)) // 去除空值
          .flatMap(t => t)
      )
      if (!vals.length) return null
      return (control.oneFlag ? vals.slice(0, 1) : vals)
        .map(o => object2Str(o))
        .filter(t => t)
        .map(id => getUser(id))
    }
    case "area": {
      let value = _.get(control, "defaultVal.value", null)
      if (_.get(control, "defaultVal.isVar", false)) {
        value = resolveDefaultVal(value, control._type, form, controlMap)
        // 如果是定位对象,则取定位对象的对应值
        if (value?.area) value = [value.area]
      }
      if (!_.isArray(value)) value = []
      return value
        ?.filter(t => t)
        .map(addr =>
          addr
            .split("-")
            .slice(0, control.level) // 统一处理level
            .join("-")
        )
    }
    case "location": {
      let { type, value, location, level } = control.defaultVal || {}
      switch (type) {
        case "const":
          return location
        case "location":
          return resolveDefaultVal(value, control._type, form, controlMap)
        case "area": {
          let addrArr = resolveDefaultVal(value, control._type, form, controlMap)
          if (addrArr.length == 0) {
            return null
          }
          let addr0 = addrArr[0].split("-")
          if (level) {
            addr0 = addr0.slice(0, level)
            addr0[0] += "省"
          }
          addr0 = addr0.join() + "政府"
          return await searchLocation(addr0)
        }
      }
      return null
    }
    case "text": {
      ;(control.defaultVal?.arr || control.defaultVal?.outputTextArr || [])
        .filter(relyItem => relyItem.value) // 过滤普通字符串
        .forEach(relyItem => {
          let relyCid = relyItem.value
          let val = resolveDefaultVal(relyCid, control._type, form, controlMap)
          if (val?.poiName || val?.address) {
            // 当val是定位数据的时候,计算为地址信息
            window[relyCid] = val.poiName + " " + val.address
          } else {
            window[relyCid] = val
          }
        })
      try {
        return eval(control.defaultVal?.text || control.defaultVal?.outputText || "")
      } catch (e) {
        console.warn(`${control.name}默认值计算失败`)
        return ""
      }
    }
    case "telephone": {
      ;(control.defaultVal?.arr || control.defaultVal?.outputTextArr || [])
        .filter(relyItem => relyItem.value) // 过滤普通字符串
        .forEach(relyItem => {
          let relyCid = relyItem.value
          let val = resolveDefaultVal(relyCid, control._type, form, controlMap)
          window[relyCid] = val
        })
      try {
        return eval(control.defaultVal?.text || control.defaultVal?.outputText || "")
      } catch (e) {
        console.warn(`${control.name}默认值计算失败`)
        return ""
      }
    }
    case "ref": {
      let relyCid = _.get(control, "defaultVal.id", "")
      return fillRefVal(control, resolveDefaultVal(relyCid, control._type, form, controlMap))
    }
    case "money":
    case "number": {
      try {
        ;(control.defaultVal?.arr || control.defaultVal?.outputTextArr || []).forEach(item => {
          if (item.value) {
            let relyCid = item.value
            let val = Number(resolveDefaultVal(relyCid, control._type, form, controlMap))
            if (isNaN(val)) return null
            window[relyCid] = val
          }
        })
        let result = eval(control.defaultVal?.text || control.defaultVal?.outputText || "")
        if (Number.isNaN(result) || !Number.isFinite(result)) return null
        return result
      } catch {
        return null
      }
    }
    case "date":
    case "time": {
      let defaultVal = control.defaultVal
      if (!defaultVal || JSON.stringify(defaultVal) === "{}" || !defaultVal.dateType) return
      switch (defaultVal.dateType) {
        case "Custom": {
          return timeCompute(defaultVal, control, defaultVal.value)
        }
        case "Now": {
          return timeCompute(defaultVal, control, new Date())
        }
        case "var": {
          let relyCid = control.defaultVal.value
          let val = resolveDefaultVal(relyCid, control._type, form, controlMap)
          return timeCompute(defaultVal, control, val)
        }
        default:
          return null
      }
    }
  }
}

export async function fillRefVal(control, val) {
  if (!val) return []
  if (!control.oneFlag || (_.isArray(val) && val.length && val[0].data)) return val
  const ids = getIdList(val)
  if (!ids.length) return []
  const { refSheetId } = control
  return getSheetDataById(refSheetId, ids[0]).then(sheetData => [sheetData])
}

// 从当前表或关联表,或系统变量 获取默认值
export function resolveDefaultVal(relyCid, type, form, controlMap) {
  if (!relyCid) return null
  let defaultVal = "text" === type ? "" : "ref" === type ? [] : null
  let fieldArr = type === "ref" ? relyCid.split("_") : _.trimStart(relyCid, "v").split("_")
  if (["CurrentUser", "CurrentLocation"].includes(fieldArr[0])) {
    switch (fieldArr[0]) {
      case "CurrentUser":
        return store.getters.userInfo?.userId
      case "CurrentLocation":
        return store.getters.location
    }
    return null
  }
  let val = form[fieldArr[0]] || defaultVal
  if (fieldArr.length > 1 && fieldArr[1]) {
    const parentVal = val
    val = _.get(val, `[0].data.${fieldArr[1]}`, defaultVal)
    const { _type, oneFlag } = controlMap[fieldArr[0]]
    if (_type === "ref" && !oneFlag) {
      if (_.isArray(val)) return val
      const id = _.get(parentVal, `[0].data.${fieldArr[1]}_id`)
      return id ? [id] : []
    }
  }
  // 对结果格式化
  return formatControlVal(val, type, controlMap?.[fieldArr[fieldArr.length - 1]])
}

function formatControlVal(val, targetType, control) {
  if ((!val || !control) && targetType === "text") return ""
  if (!control) return null
  switch (control._type) {
    case "location":
      return val
    case "time": {
      if (["半年度", "季度"].includes(control.timeType)) {
        val = getSpecialTime(control.timeType, val)
      } else {
        let djFormat = timeTypeList.find(timeType => timeType.value === control.timeType)?.djFormat
        if (djFormat && val) {
          val = dj(val, "YYYY-MM-DD HH:mm:ss").format(djFormat)
        }
      }
      break
    }
    case "option": {
      val = (val || []).join(",")
      break
    }
    case "staff":
    case "department":
    case "company": {
      if (targetType === "text") {
        val = (val || [])
          .map(t => t.name)
          .filter(t => t)
          .join(",")
      } else {
        val = (val || []).filter(t => _.isObject(t))
      }
      break
    }
  }
  return val
}

export function getSpecialTime(timeType, val) {
  let showValue = ""
  switch (timeType) {
    case "半年度": {
      let halfYear = halfYears.find(halfYear => getHalf(val) === halfYear.value)
      showValue = val.slice(0, 4) + "年" + halfYear.label
      break
    }
    case "季度": {
      let quarter = quarters.find(quarter => dj(val).quarter() === quarter.value)
      showValue = val.slice(0, 4) + "年" + quarter.label
      break
    }
  }
  return showValue
}

export function getHalf(date) {
  let year = dj(date).year()
  if (
    dj(date).isSameOrAfter(dj(year + "-01-01 00:00:00").format("YYYY-MM-DD HH:mm:ss")) &&
    dj(date).isSameOrBefore(dj(year + "-06-30 23:59:59").format("YYYY-MM-DD HH:mm:ss"))
  )
    return 1
  if (
    dj(date).isSameOrAfter(dj(year + "-07-01 00:00:00").format("YYYY-MM-DD HH:mm:ss")) &&
    dj(date).isSameOrBefore(dj(year + "-12-31 23:59:59").format("YYYY-MM-DD HH:mm:ss"))
  )
    return 2
}

// 分组获取 availableSheetList
export function getAvailableSheetList(availableSheets) {
  return availableSheets.map((app, index) => {
    return {
      id: app.id,
      label: index === 0 ? app.name + " [当前应用]" : app.name + " [共享应用]",
      options: app.sheets.map(sheet => {
        return {
          label: sheet.name,
          value: sheet.sheetId
        }
      })
    }
  })
}

// 通过 sheetId 从 availableSheets中 获取 sheetInfo
export function getSheetInAvailableSheets(availableSheets = [], sheetId) {
  if (availableSheets.length === 0 || !sheetId) return {}
  let sheet
  for (let app of availableSheets) {
    sheet = app.sheets.find(i => i.sheetId === sheetId)
    if (sheet) break
  }
  return sheet || {}
}

// 通过 sheetId 从 availableSheets中 获取 appId
export function getAppIdInAvailableSheets(availableSheets = [], sheetId) {
  if (availableSheets.length === 0 || !sheetId) return ""
  let sheetAppIdMap = availableSheets.reduce((acc, app) => {
    if (app.sheets.length == 0) return acc
    for (let sheet of app.sheets) acc[sheet.sheetId] = app.id
    return acc
  }, {})
  return sheetAppIdMap[sheetId] || ""
}

// 表单数据提交前的转换
export function beforeSubmit({ form, fieldsMap, skipRelatedControl = true } = {}) {
  let data = deepClone(form)
  for (let key in data) {
    if (!fieldsMap[key]) continue
    switch (fieldsMap[key]._type) {
      case "location": {
        if (data[key]) {
          delete data[key].searchText
          delete data[key].detail
        }
        if (_.isEmpty(data[key])) {
          delete data[key]
        }
        break
      }
      case "ref": {
        // 编辑页关联表展开关联多条为string,不需提交
        if (_.isString(data[key])) data[key] = []
        if (data[key] && data[key].length > 0) {
          let field = fieldsMap[key]
          data[key] = data[key].reduce((acc, cur) => {
            if (getVarType(cur) == "Object") {
              if (skipRelatedControl && field.related && !field.treeKey && !field.oneFlag) {
                acc.push(cur)
              } else if (cur.id) acc.push(cur.id)
            } else if (getVarType(cur) == "String") {
              acc.push(cur)
            }
            return acc
          }, [])
        }
        break
      }
      case "staff":
      case "department":
      case "company": {
        data[key] = _.isArray(data[key])
          ? data[key]
              .map(o => {
                if (_.isObject(o)) return o.id
                if (_.isString(o)) return o
                return null
              })
              .filter(t => t)
          : []
        break
      }
      case "file": {
        if (data[key] && Array.isArray(data[key])) data[key] = data[key].map(i => i.id)
        break
      }
      case "time": {
        if (!data[key]) data[key] = null
        break
      }
      case "sign": {
        if (data[key]) data[key] = data[key].id
        break
      }
      case "code": {
        if (data[key] === " ") {
          delete data[key]
        } else {
          if (!data[key].token) {
            delete data[key]
          }
        }
        break
      }
    }
  }
  return data
}

export function getControlOptions(control, form) {
  let rawOptions = control.options || []
  // 动态数据源已经在后端处理好,直接使用控件的option即可
  if (control.optionType === "动态数据源") {
    return rawOptions
  }
  // 判断选项依赖
  if (!control.linkage?.cid || control.isField) return rawOptions
  let arr = form[control.linkage?.cid] || []
  let curValArr = _.flatten(arr.map(value => control.linkage.map[value] || []))
  let curOptions = rawOptions.filter(option => curValArr.includes(option.value))
  return curOptions
}

export function getUserControlScope(control, form, allControlMap) {
  if (_.isEmpty(control.scope)) return null
  return getUsers(
    control.scope.flatMap(({ type, value }) => {
      if (_.startsWith(value, "v")) {
        value = resolveDefaultVal(value, type, form, allControlMap)
          .map(t => t?.id)
          .filter(t => t)
      }
      let vArr = [].concat(value) // 统一处理成数组
      switch (type) {
        case "user":
        case "staff":
          return vArr
        case "department":
          return getUserIdsByDepartment(vArr)
        case "role":
          return getUserIdsByRole(vArr)
      }
      return []
    })
  )
}

export async function getLocationScope(control, form) {
  let { type, value, location, level, radius } = control.range

  // 固定定位
  if (type === "const" && !_.isEmpty(location)) {
    return { lng: location.lng, lat: location.lat, radius }
  }
  // 当前定位
  if (value === "vCurrentLocation") {
    location = store.getters.location
    return _.isEmpty(location) ? null : { lng: location.lng, lat: location.lat, radius }
  }
  // 根据其他控件计算
  if (["area", "location"].includes(type) && value) {
    let newVal = form[value.slice(1)]
    if (_.isEmpty(newVal)) return null
    if (type === "location") {
      return { lng: newVal.lng, lat: newVal.lat, radius }
    }
    if (type === "area") {
      let addr0 = newVal[0].split("-")
      if (level) {
        addr0 = addr0.slice(0, level)
        addr0[0] += "省"
      }
      addr0 = addr0.join() + "政府"
      let location = await searchLocation(addr0)
      if (location) {
        return { lng: location.lng, lat: location.lat, radius }
      }
    }
  }
  return null
}

// 获取校验规则
export function getRules(controls, formGetterFunc, allControlMap, sheetId) {
  if (!controls.length) return {}
  let rule = {}
  let ruleFunList = [
    requireRule,
    countLimitRule,
    valueRangeRule,
    timeScopeRule,
    commonRangeRule,
    lenLimitRule,
    regexRule,
    telephoneRule,
    mailRule,
    urlRule
  ]
  controls
    .filter(control => !["sn"].includes(control._type))
    .forEach(control => {
      let rules = (control.isField ? [requireRule] : ruleFunList)
        .map(func => func(control, formGetterFunc, allControlMap, sheetId))
        .filter(t => t)
      if (rules.length) {
        rule[control._cid] = rules
      }
    })
  return rule
}
function requireRule(control) {
  if (!control.required) return null
  let msg
  if (["file", "staff"].includes(control._type)) msg = "请添加" + control.name
  else msg = "请输入" + control.name
  return {
    validator: (rule, value, callBack) => {
      let v = value
      if (!_.isNumber(v) && !_.isBoolean(v) && _.isEmpty(v)) callBack(msg)
      else callBack()
    },
    trigger: "manual"
  }
}
function countLimitRule(control) {
  if (control.countLimit?.length !== 2 || control.oneFlag) return null
  let [min, max] = control.countLimit
  return {
    validator: (rule, value, callBack) => {
      if (min !== null && max !== null && (value?.length < min || value?.length > max)) {
        callBack(`请选择${min}到${max}之间个项`)
        return
      }
      if (min === null && max !== null && value?.length > max) {
        callBack(`请选择小于等于${max}项`)
        return
      }
      if (min !== null && max === null && value?.length < min) {
        callBack(`请选择大于等于${min}项`)
        return
      }
      callBack()
    },
    trigger: "manual"
  }
}
function valueRangeRule(control) {
  if (control.valueRange?.length !== 2) return
  let [min, max] = control.valueRange
  const nameMap = {
    number: "数值",
    money: "金额"
  }
  const controlType = nameMap[control._type] || "数"
  return {
    validator: (rule, value, callBack) => {
      if (min !== null && max !== null && (value < min || value > max)) {
        callBack(`请输入${min}到${max}之间的${controlType}`)
        return
      }
      if (min === null && max !== null && value > max) {
        callBack(`请输入小于等于${max}的${controlType}`)
        return
      }
      if (min !== null && max === null && value < min) {
        callBack(`请输入大于等于${min}的${controlType}`)
        return
      }
      callBack()
    },
    trigger: "manual"
  }
}
function lenLimitRule(control) {
  if (control.lenLimit?.length !== 2) return null
  let [min, max] = control.lenLimit
  return {
    validator: (rule, value, callBack) => {
      if (min !== null && max !== null && (value?.length < min || value?.length > max)) {
        callBack(`请输入${min}到${max}个字符`)
        return
      }
      if (min === null && max !== null && value?.length > max) {
        callBack(`请输入小于等于${max}个字符`)
        return
      }
      if (min !== null && max === null && value?.length < min) {
        callBack(`请输入大于等于${min}个字符`)
        return
      }
      callBack()
    },
    trigger: "manual"
  }
}
function timeScopeRule(control) {
  if (!control.timeScope) return null
  const { weekLimit, timeRange, dateRange } = control.timeScope
  const weekLimitEnabled = _.isNumber(weekLimit) && control.timeType?.includes("日")
  const timeRangeEnable = _.isArray(timeRange) && control.timeType?.includes("时")
  const dateRangeEnable = _.isArray(dateRange) && control.timeType?.includes("日")
  const weekLimitStr = weekLimitEnabled
    ? weekOptionList
        .filter(week => weekLimit & (1 << week.value))
        .map(week => week.label)
        .join(",")
    : ""
  const timeRangeStr = timeRangeEnable ? timeRange.join("-") : ""
  const dateRangeStr = dateRangeEnable ? dateRange.join("至") : ""
  return {
    validator: (rule, value, callBack) => {
      const v = value
      if (v) {
        const time = dj(v)
        const isoWeek = (time.day() - 1 + 7) % 7
        const timeStr = v.split(" ")[1]
        // 日期限制
        const isSameOrBefore = require("dayjs/plugin/isSameOrBefore")
        const isSameOrAfter = require("dayjs/plugin/isSameOrAfter")
        dj.extend(isSameOrBefore)
        dj.extend(isSameOrAfter)
        const date = new Date(v.split(" ")[0])
        if (!dateRange?.includes("Now")) {
          if (
            dateRangeEnable &&
            (dj(date).isBefore(new Date(dateRange[0]), "date") ||
              dj(date).isAfter(new Date(dateRange[1]), "date"))
          ) {
            callBack(`请选择${dateRangeStr}间的日期`)
            return
          }
        } else {
          const now = dj(new Date()).format("YYYY-MM-DD")
          if (dateRangeEnable && dateRange[1] == null && dj(date).isBefore(new Date(), "date")) {
            callBack(`请选择${now}及其后的日期`)
            return
          }
          if (dateRangeEnable && dateRange[0] == null && dj(date).isAfter(new Date(), "date")) {
            callBack(`请选择${now}及其前的日期`)
            return
          }
        }
        // 判断星期几限制
        if (weekLimitEnabled && !(weekLimit & (1 << isoWeek))) {
          callBack(`请选择${weekLimitStr}对应的日期`)
          return
        }
        // 时间段限制
        if (timeRangeEnable && (timeStr < timeRange[0] || timeStr > timeRange[1])) {
          callBack(`请选择${timeRangeStr}内的时间`)
          return
        }
      }
      callBack()
    },
    trigger: "manual"
  }
}
function commonRangeRule(control, formGetterFunc, allControlMap, sheetId) {
  switch (control._type) {
    case "location": {
      if (!control.range) return null
      return {
        validator: async (rule, value, callBack) => {
          if (!value) {
            callBack()
            return
          }
          let scope = await getLocationScope(control, formGetterFunc())
          if (!scope) {
            callBack()
            return
          }
          let distance = getDistance(scope.lng, scope.lat, value.lng, value.lat)
          if (distance > scope.radius) callBack(`超出定位范围`)
          else callBack()
        },
        trigger: "manual"
      }
    }
    case "option": {
      return {
        validator: (rule, value, callBack) => {
          if (_.isEmpty(value)) {
            callBack()
            return
          }
          let vals = getControlOptions(control, formGetterFunc()).map(t => t.value)
          let invalidVal = value.find(v => !vals.includes(v))
          if (invalidVal) callBack(`值 ${invalidVal} 不在范围内`)
          else callBack()
        },
        trigger: "manual"
      }
    }
    case "staff": {
      if (!control.scope) return null
      return {
        validator: (rule, value, callBack) => {
          if (_.isEmpty(value)) {
            callBack()
            return
          }
          let scope = getUserControlScope(control, formGetterFunc(), allControlMap)
          if (!scope) {
            callBack()
            return
          }
          let vals = scope.map(t => t.id)
          let invalidVal = value.find(v => !vals.includes(v.id))
          if (invalidVal) callBack(`值 ${invalidVal.name} 不在范围内`)
          else callBack()
        },
        trigger: "manual"
      }
    }
    case "ref": {
      if (_.isEmpty(control.filters)) return null
      return {
        validator: async (rule, value, callBack) => {
          if (_.isEmpty(value)) {
            callBack()
            return
          }
          let dataIds = (value || []).map(sheetData => sheetData.id)
          if (control.refSheetId && !_.isEmpty(dataIds)) {
            let pagedData = await getSheetViewData({
              sheetId: control.refSheetId,
              dataIds: dataIds,
              refSheetId: sheetId,
              refControlId: control._cid,
              refSheetData: {
                sheetId: sheetId,
                data: beforeSubmit({
                  form: formGetterFunc(),
                  fieldsMap: allControlMap,
                  skipRelatedControl: true
                })
              }
            })
            if (!pagedData.totalElements) callBack(`值不在范围内`)
            else callBack()
          }
        },
        trigger: "manual"
      }
    }
  }
  return null
}
function regexRule(control) {
  if (!control.regex) return null
  return {
    validator: (rule, value, callBack) => {
      if (!value) {
        callBack()
        return
      }
      const reg = "/" + control.regex + "/"
      if (!eval(reg).test(value)) {
        let msg = ""
        let expression = commonExpressions.find(item => item.expression === control.regex)
        if (expression === undefined) msg = "不符合格式要求"
        else msg = "不符合" + expression.label + "格式要求"
        callBack(msg)
      } else callBack()
    },
    trigger: "manual"
  }
}
function telephoneRule(control) {
  if (control._type !== "telephone") return null
  return {
    validator: (rule, value, callBack) => {
      const text = value
      if (!text) {
        callBack()
        return
      }
      const infos = text?.split(" ")
      if (infos.length === 1) {
        const reg = /^1\d{10}(-\d+)?$/
        if (!reg.test(infos[0])) {
          callBack("手机号格式错误")
        } else callBack()
      } else {
        callBack()
      }
    },
    trigger: "manual"
  }
}
function mailRule(control) {
  if (control._type !== "mail") return null
  return {
    validator: (rule, value, callBack) => {
      const text = value
      if (!text) {
        callBack()
        return
      }
      const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
      if (!reg.test(text)) {
        callBack(`邮箱格式错误`)
        return
      } else callBack()
    },
    trigger: "manual"
  }
}
function urlRule(control) {
  if (control._type !== "url") return null
  return {
    validator: (rule, value, callBack) => {
      const text = value
      if (!text) {
        callBack()
        return
      }
      // eslint-disable-next-line no-useless-escape
      const reg = /^http(s)?:\/\/[\w\-]+(\.[\w\-]+)+([\w\-.,@?^=%&:\/~+#]*[\w\-@?^=%&\/~+#])?$/
      if (!reg.test(text)) {
        callBack(`链接格式错误`)
        return
      } else callBack()
    },
    trigger: "manual"
  }
}

// 构造筛选条件
export function getFilter(control, method, value) {
  return {
    key: control._cid,
    compareMethod: method,
    type: control._type,
    varItems: value
  }
}

const cache = {}
// 减少内存使用
export function getAllControlMap(availableSheets) {
  let appId = availableSheets[0]?.id
  if (!appId) return []
  if (!cache[appId]) {
    cache[appId] = _.keyBy(
      availableSheets
        .flatMap(app => app.sheets)
        .flatMap(sheet => sheet.controls)
        .map(c => transFieldControl(c)),
      "_cid"
    )
  }
  return cache[appId]
}
